/**
 * The first visit's language (owner, 2026-11-01): with no language kept in the preferences yet, the UI opens in the
 * first of the browser's languages the app has, else English. Nothing is stored: choosing a language (profile, the auth
 * pages' picker) or signing in with a profile language still sets it, as before.
 */

/** Browser language codes (BCP 47 primary subtag) whose catalogue folder uses the legacy code. */
const LEGACY_CODES: Readonly<Record<string, string>> = { cs: 'cz', el: 'gr' }

/**
 * The first of `languages` (most preferred first, as `navigator.languages`) that is in `available`, by its primary
 * subtag (`fr-BE` → `fr`, `cs-CZ` → `cz`); `null` when none is. English counts: an English-first browser stays English.
 */
export function browserLocale(languages: readonly string[], available: readonly string[]): string | null {
  for (const language of languages) {
    const primary = language.trim().toLowerCase().split(/[-_]/)[0] ?? ''
    const code = LEGACY_CODES[primary] ?? primary
    if (code && available.includes(code)) return code
  }
  return null
}

/** The browser's languages, most preferred first (none outside a browser). */
export function navigatorLanguages(): readonly string[] {
  if (typeof navigator === 'undefined') return []
  if (navigator.languages?.length) return navigator.languages
  return navigator.language ? [navigator.language] : []
}
